import { AuthRepository } from "@/repositories/auth.repository";
import supabase from "@/lib/supabase";

export interface ChangePasswordPayload {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

export async function changePassword(payload: ChangePasswordPayload): Promise<void> {
  if (payload.newPassword !== payload.confirmPassword) {
    throw new Error("Passwords do not match");
  }

  if (payload.newPassword.length < 6) {
    throw new Error("New password must be at least 6 characters");
  }

  const { data: { user: authUser } } = await supabase.auth.getUser();
  const email = authUser?.email;
  if (!email) {
    throw new Error("You must be signed in to change your password");
  }

  await AuthRepository.changePassword(email, payload.currentPassword, payload.newPassword);
}
